import type { KeyboardEvent } from 'react';

import { type Theme, alpha } from '@mui/material/styles';

export const UNMATCHED_ROW_ID = '__unmatched__';
export const SURCHARGES_TABLE_COLUMN_COUNT = 14;

export const dropdownContentSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  px: 3,
  py: 1.5,
  width: '100%',
} as const;

const TAB_TABLE_HEAD_TYPE_SX = {
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
} as const;

/** Grey for a table of our own data, blue below for Salesforce data. */
export const tabTableHeadSx = {
  '& .MuiTableCell-head': {
    ...TAB_TABLE_HEAD_TYPE_SX,
    bgcolor: 'grey.100',
    color: 'text.secondary',
  },
} as const;

/** The blue the blackout, surcharges and campaign schedule tabs already use for Salesforce data. */
export const salesforceTableHeadSx = {
  '& .MuiTableCell-head': {
    ...TAB_TABLE_HEAD_TYPE_SX,
    bgcolor: (theme: Theme) => alpha(theme.palette.info.main, 0.06),
    color: 'info.dark',
  },
} as const;

export function getDropdownCellSx(isExpanded: boolean) {
  return {
    borderBottom: isExpanded ? 1 : 0,
    p: 0,
  };
}

export function toggleExpandedRow(expandedRows: Set<string>, rowId: string) {
  const nextExpandedRows = new Set(expandedRows);
  if (nextExpandedRows.has(rowId)) {
    nextExpandedRows.delete(rowId);
  } else {
    nextExpandedRows.add(rowId);
  }
  return nextExpandedRows;
}

export function handleExpandRowKeyDown(event: KeyboardEvent, onToggle: () => void) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onToggle();
  }
}

export function getUniqueRoomRateCount(assignments: Array<{ roomRateId: string }>) {
  return new Set(assignments.map((assignment) => assignment.roomRateId)).size;
}
